// extracted by mini-css-extract-plugin
export default {"menu":"WidgetDownloadMenu_menu__AXj3r","menuItem":"WidgetDownloadMenu_menuItem__wfY8j"};